<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true">
  <div class="left-items" left>
    @if ((currentOuId$ | async) === (currentFolder?.organization_unit_id)) {
      @if (!(isReader$ | async) && currentFolder?.activities?.length > 0) {
        <button
          mat-icon-button
          type="button"
          (click)="createProgram()"
          [matTooltip]="'pinboard.folder.program.create.tooltip' | translate"
          >
          <mat-icon>date_range</mat-icon>
        </button>
      }
      @if (!(isReader$ | async) && currentFolder?.activities?.length > 0) {
        <mat-checkbox class="top-checkbox" [formControl]="selectActivitiesControl">
          {{ 'pinboard.folder.activities.select.label' | translate }}
        </mat-checkbox>
      }
      @if (!(isReader$ | async)) {
        <a class="activities-link" (click)="goToActivities()">
          {{ 'pinboard.folder.activities.add.label' | translate }}
        </a>
      }
    } @else {
      @if (isAdmin$ | async) {
        <app-owner-chip [owningOuId]="currentFolder?.organization_unit_id" [isTheOwner]="(currentOuId$ | async) === (currentFolder?.organization_unit_id)"></app-owner-chip>
      }
    }

  </div>

  @if ((currentOuId$ | async) === (currentFolder?.organization_unit_id)) {
    <div right>
      <button mat-icon-button type="button" (click)="share()" [matBadge]="(sharesBadge$ | async)" matBadgePosition="above after" matBadgeColor="accent">
        <mat-icon>share</mat-icon>
      </button>
      @if (hasOUWritePermission$ | async) {
        <button
          mat-icon-button
          type="button"
          (click)="deletePinbordFolder()"
          [matTooltip]="'pinboard.folder.delete.tooltip' | translate"
          >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  }
</app-doenkids-menu-bar>
<div content>
  @if (currentFolder) {
    <div class="page-content">
    <h2>{{ currentFolder.name }}</h2>
    @if (currentFolder.activities.length === 0) {
      <p>
        <span>{{ 'pinboard.folder.activities.none' | translate }}&nbsp;</span>
      </p>
    }
    @if (currentFolder.activities.length > 0) {
      <ngx-masonry [options]="{ gutter: 25, transitionDuration: '0s', fitWidth: true }">
        @for (activity of currentFolder.activities; track activity) {
          <ngxMasonryItem class="masonry-item">
            <app-activity-card
              (click)="activityClicked(activity)"
              [activity]="activity"
              [class.selected]="(isSelectingActivties$ | async) && activityIsSelected(activity)"
            ></app-activity-card>
          </ngxMasonryItem>
        }
      </ngx-masonry>
    }
    </div>
  }
  @if (!(isReader$ | async) && (isSelectingActivties$ | async)) {
    <app-selected-activities [pinbord]="currentFolder"></app-selected-activities>
  }
</div>
</app-page-content>
